            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row>
          <sw-inputs
            inputTabla="datos_asesor"
            inputCampo="documento"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_asesor"
            inputCampo="name"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_asesor"
            inputCampo="email"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_asesor"
            inputCampo="telefonos"
            :lg="6">
          </sw-inputs>
        </b-row>          
        <b-row style="width:100%;margin-top:26px">
            <b-col :md="6">                              
              <table class="table" style="margin-top:36px">
                  <thead class="thead-dark">
                    <tr>
                      <th>R</th>
                      <th>AFILIACION EPS + RIESGO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="font-weight:500">1</td>
                      <td>
                        <b-input-group size="md" prepend="$" append="">
                          <vue-numeric 
                            :empty-value="0"       
                            separator="."   
                            class="form-control"       
                            v-model="dataForm[namePath].datos_asesor.r1"
                            :precision="0">
                          </vue-numeric> 
                        </b-input-group>
                      </td>                                 
                    </tr>                               
                    <tr>
                      <td style="font-weight:500">2</td>
                      <td>
                        <b-input-group size="md" prepend="$" append="">
                          <vue-numeric 
                            :empty-value="0"       
                            separator="."   
                            class="form-control"       
                            v-model="dataForm[namePath].datos_asesor.r2"
                            :precision="0">
                          </vue-numeric> 
                        </b-input-group>
                      </td>                                
                    </tr>                                 
                    <tr>
                      <td style="font-weight:500">3</td>
                      <td>
                        <b-input-group size="md" prepend="$" append="">
                          <vue-numeric 
                           :empty-value="0"       
                            separator="."   
                            class="form-control"       
                            v-model="dataForm[namePath].datos_asesor.r3"
                            :precision="0">
                          </vue-numeric> 
                        </b-input-group>
                      </td> 
                    </tr>
                    <tr>
                      <td style="font-weight:500">4</td>
                      <td>
                        <b-input-group size="md" prepend="$" append="">
                          <vue-numeric 
                            :empty-value="0"       
                            separator="."   
                            class="form-control"       
                            v-model="dataForm[namePath].datos_asesor.r4"
                            :precision="0">
                          </vue-numeric> 
                        </b-input-group>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-weight:500">5</td>
                      <td>
                        <b-input-group size="md" prepend="$" append="">
                          <vue-numeric 
                      :empty-value="0"       
                            separator="."   
                            class="form-control"       
                            v-model="dataForm[namePath].datos_asesor.r5"
                            :precision="0">
                          </vue-numeric> 
                        </b-input-group>
                      </td>                                  
                    </tr>
                  </tbody>
              </table>
            </b-col>
            <b-col  :md="6" >                                                          
              <b-form-group
                style="margin-top:75px"
                label="Afiliación CCF"
                >
                  <b-input-group size="md" prepend="$" append="">
                    <vue-numeric 
                      :empty-value="0"       
                      separator="."   
                      class="form-control"       
                      v-model="dataForm[namePath].datos_asesor.ccf"
                      :precision="0">
                    </vue-numeric> 
                  </b-input-group>
              </b-form-group> 
              <b-form-group
                label="Afiliación AFP"
                style="margin:17px 0 0"
                >
                  <b-input-group size="md" prepend="$" append="">
                    <vue-numeric 
                      :empty-value="0"       
                      separator="."   
                      class="form-control"       
                      v-model="dataForm[namePath].datos_asesor.afp"
                      :precision="0">
                    </vue-numeric> 
                  </b-input-group>
              </b-form-group>        
              <b-form-group
                label="Comisión mensual"
                style="margin:15px 0 0"
                >
                  <b-input-group size="md" prepend="$" append="">
                    <vue-numeric 
                      :empty-value="0"       
                      separator="."   
                      class="form-control"       
                      v-model="dataForm[namePath].datos_asesor.comision"
                      :precision="0">
                    </vue-numeric> 
                  </b-input-group>
              </b-form-group>  
              <b-form-group
                label="Administración"
                style="margin:15px 0 0"
                >
                  <b-input-group size="md" prepend="$" append="">
                    <vue-numeric 
                      :empty-value="0"       
                      separator="."   
                      class="form-control"       
                      v-model="dataForm[namePath].datos_asesor.admin"
                      :precision="0">
                    </vue-numeric> 
                  </b-input-group>
              </b-form-group>                                         
            </b-col>
        </b-row>         
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="dataIndex[namePath]"
            nameBtn="asesor"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
export default 
{
  name: 'swmodalasesor',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,
    VueNumeric        
  },
  props: {
  },
  async created()
  {
    if (this.dataIndex[this.namePath]!==false)
    {      
      await this.updateDataForm({state:'datos_asesor', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_asesor})
      await this.updateGlobal({state:'openModal/modal/loaded',data:true})
    }
  },
  computed: { 
  },
  destroyed()
  {    
		this.resetDataIndex()
		this.resetDataForm()
		this.resetDataPost()
  },
  methods: {
    save(event)
    {
     this.$emit('save', { save: event.save, ftn: 'asesorFtn' } )
    }
  }
}
</script>
<style>
</style>